module.exports = __webpack_public_path__ + "assets/img/ios-portrait1.8005d3c.png";


//////////////////
// WEBPACK FOOTER
// ./website/assets/ios-portrait1.png
// module id = Yaey
// module chunks = 50